import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'cnxslcc_stopovers';
export const route = 'cnxslcc_stopovers/[[...params]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "cnxslcc_stopovers" */
/* webpackPrefetch: true */
'../components/StopoverSelectorPage')));